import axios from 'axios'
import {clearToken} from "./auth-client";

function client(endpoint, {body, ...customConfig} = {}, method = 'post', withToken = true) {
    const token = window.localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_KEY)
    const headers = {'content-type': 'application/json'}
    if (token && withToken) {
        headers.sessionId = token
    }
    const config = {
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers
        },
    }
    return axios({
            method: method,
            url: endpoint,
            data: body,
            ...config,
        }
    ).then(r => r.data)
        .catch(error => {
            // Benutzer automatisch ausloggen, wenn nicht mehr autorisiert
            if (error.response?.status === 401) {
                clearToken()
                window.location.reload()
            }
            throw error
        })
}


export default client